<section
  class="relative my-2 overflow-hidden rounded-md bg-gradient-to-br from-blue-600 via-blue-600 to-blue-700 p-3 text-white shadow-sm"
  aria-labelledby="ai-summary-heading"
  aria-describedby="ai-summary-disclaimer"
  [attr.aria-busy]="isLoading()"
>
  <!-- Subtle decorative dots -->
  <div
    class="pointer-events-none absolute inset-0 opacity-60"
    aria-hidden="true"
  >
    <span
      class="absolute top-4 right-8 h-1 w-1 rounded-full bg-white/60"
    ></span>
    <span
      class="absolute top-10 right-20 h-1 w-1 rounded-full bg-white/40"
    ></span>
    <span
      class="absolute right-28 bottom-5 h-1.5 w-1.5 rounded-full bg-white/30"
    ></span>
  </div>

  <div class="relative" aria-live="polite">
    <!-- Header row -->
    <div class="mb-2 flex items-center justify-between gap-3">
      <div class="flex items-center gap-1">
        <div aria-hidden="true">
          <mat-icon class="!h-6 !w-6 !text-base" aria-hidden="true"
            >auto_awesome</mat-icon
          >
        </div>
        <div>
          <div class="flex flex-wrap items-center gap-1.5">
            <h3
              id="ai-summary-heading"
              class="font-lato m-0 text-sm font-bold text-white"
            >
              IQ Observations
            </h3>
            <span
              class="font-lato rounded-full bg-white/15 px-2 py-0.5 text-[10px] font-bold tracking-wide text-white/70 uppercase"
            >
              AI-generated
            </span>
          </div>
          <p
            id="ai-summary-disclaimer"
            class="font-lato m-0 text-[10px] text-white/60"
          >
            Review for accuracy before acting.
          </p>
        </div>
      </div>
      @if (updatedLabel()) {
        <span
          class="font-lato shrink-0 self-start pt-0.5 text-[10px] text-white/50"
        >
          {{ updatedLabel() }}
        </span>
      }
    </div>

    <!-- Body -->
    @if (isLoading()) {
      <div class="py-1" role="status" aria-label="Generating AI ticket summary">
        <div class="h-3 w-10/12 animate-pulse rounded bg-white/20"></div>
        <div class="mt-2 h-3 w-8/12 animate-pulse rounded bg-white/20"></div>
      </div>
    } @else {
      <p class="font-lato m-0 text-xs leading-5 text-white/95">
        {{ summaryText() }}
      </p>

      <!-- Chips — only shown when there's actual data -->
      @let obsCount = historicalObservations().length;

      @if (obsCount > 0) {
        <div
          class="font-lato mt-2 flex flex-wrap items-center justify-between gap-2"
        >
          <div
            class="flex flex-wrap gap-1.5"
            role="list"
            aria-label="Summary highlights"
          >
            <span
              class="rounded-full bg-white/15 px-2.5 py-1 text-[11px] font-semibold text-white ring-1 ring-white/10"
              role="listitem"
            >
              {{ historicalObservationLabel() }}
            </span>
            @if (actionItemCount() > 0) {
              <span
                class="rounded-full bg-white/15 px-2.5 py-1 text-[11px] font-semibold text-white ring-1 ring-white/10"
                role="listitem"
              >
                {{ actionItemLabel() }}
              </span>
            }
          </div>

          @if (hasHistoricalObservations()) {
            <button
              type="button"
              class="font-lato inline-flex shrink-0 items-center gap-1 text-[11px] font-semibold text-white underline decoration-white/40 underline-offset-4 transition hover:decoration-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
              [attr.aria-label]="historicalObservationsButtonLabel()"
              (click)="
                openSummaryModal(
                  $safeNavigationMigration(ticket()?.Service__r?.Name)
                )
              "
            >
              View historical IQ observations
              <mat-icon class="!h-3.5 !w-3.5 !text-sm" aria-hidden="true"
                >arrow_forward</mat-icon
              >
            </button>
          }
        </div>
      }
    }
  </div>
</section>
